import axios from "axios";

export const state = {
    documents: [],
    loadingDocuments: false,
};

export const getters = {
    documents: state => state.documents,
    loadingDocuments: state => state.loadingDocuments,
};

export const mutations = {
    setDocuments(state, newValue) {
        state.documents = newValue || []
    },
    setLoadingDocuments(state, newValue) {
        state.loadingDocuments = newValue
    },
};

export const actions = {
    async fetchDocuments({ commit }) {
        commit('setLoadingDocuments', true);
        try {
            const res = await axios.get('/documents');
            commit('setDocuments', res.data.documents || []);
        } catch (error) {
            alert(error);
        } finally {
            commit('setLoadingDocuments', false);
        }
    },
};